<app-navigation class="sticky-top" (showAssistantChange)="showAssistantMenu()"
    (emitLogout)="logoutClick()"></app-navigation>
<ng-template #templateModal>
    <div class="p-3 text-center">
        <p>
            You will be timed out in {{countdown}} seconds.
        </p>
        <div class="my-2">
            <progressbar type="danger" [value]="countdown" [max]="timeoutWarningInSeconds" [striped]="true" [animate]="true">
            </progressbar>
    
        </div>
        <button type="button" class="mx-2 height-34" (click)="confirm()">Continue Session</button>
        <button type="button" class="mx-2 height-34" (click)="decline()">Logout</button>
    </div>
</ng-template>


<main>
    @if(showMenu && showAssistant){
        <!-- <lib-assistant class="float-end lib-layout" style="margin-top: 64px;"></lib-assistant> -->
        <limast-lib-imanage-assistant #cmpAssistant class="float-end lib-layout" style="margin-top: 64px;"></limast-lib-imanage-assistant>
    <!-- <iframe #iframeAssist [src]="safeUrl">
    </iframe> -->
    }
    <!-- <limast-lib-imanage-assistant #cmpAssistant class="navbar navbar-inverse sidebar lib-layout align-items-start"
        [hidden]="!showMenu || !showAssistant" *ngIf="isEmbed">
    </limast-lib-imanage-assistant> -->
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>